(function () {
  var drawer = document.getElementById('quick-add');
  if (!drawer) return;

  var titleEl   = drawer.querySelector('.quick-add__title');
  var imageEl   = drawer.querySelector('.quick-add__image');
  var priceEl   = drawer.querySelector('.quick-add__price');
  var variantsEl = drawer.querySelector('.quick-add__variants');
  var qtyValEl  = drawer.querySelector('.quick-add__qty-val');
  var submitBtn = drawer.querySelector('.quick-add__submit');
  var detailsLink = drawer.querySelector('.quick-add__details');
  var closeBtn  = drawer.querySelector('.quick-add__close');
  var backdrop  = drawer.querySelector('.quick-add__backdrop');

  var qty = 1;
  var selectedVariant = null;   // full variant object (has .id and .price)
  var preorderNote = '';        // "Ships around November 16" when the product is on pre-order (data-preorder)
  var addLabel = 'Add to Bag';  // 'Pre-order' for pre-order products
  var cartTotalCents = 0;       // cart total when drawer opened

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function unitPrice(variant) {
    var m = /^(\d+(?:\.\d+)?)\s*(oz|ounce)/i.exec(variant.title || '');
    if (!m) return '';
    var oz = parseFloat(m[1]);
    if (!oz) return '';
    return '$' + (variant.price / 100 / oz).toFixed(2) + '/oz';
  }

  function showPrice(variant) {
    if (!priceEl) return;
    priceEl.innerHTML = '';
    if (!variant) return;

    var u = unitPrice(variant);
    var compare = parseInt(variant.compare_at_price, 10) || 0;

    var now = document.createElement('span');
    now.className = 'fm-price__now';
    now.textContent = formatMoney(variant.price);
    priceEl.appendChild(now);

    if (compare > variant.price) {
      var was = document.createElement('s');
      was.className = 'fm-price__was';
      was.textContent = formatMoney(compare);
      priceEl.appendChild(was);

      var off = document.createElement('span');
      off.className = 'fm-price__off';
      off.textContent = Math.round(((compare - variant.price) / compare) * 100) + '% off';
      priceEl.appendChild(off);
    }

    if (u) {
      var unit = document.createElement('span');
      unit.className = 'fm-price__unit';
      unit.textContent = u;
      priceEl.appendChild(unit);
    }
  }

  // Preview the free-shipping bar as if the pending selection were in the cart
  function previewShipBar() {
    if (!window.FMCart || !window.FMCart.updateShipBars) return;
    var pending = selectedVariant ? selectedVariant.price * qty : 0;
    window.FMCart.updateShipBars(cartTotalCents + pending);
  }

  function refreshCartTotalThenPreview() {
    if (!window.FMCart || !window.FMCart.updateShipBars) return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { cartTotalCents = cart.total_price; previewShipBar(); })
      .catch(function () {});
  }

  function open(trigger) {
    var title    = trigger.dataset.title;
    var url      = trigger.dataset.url;
    var image    = trigger.dataset.image;
    var variants = JSON.parse(trigger.dataset.variants);

    qty = 1;
    selectedVariant = null;
    preorderNote = trigger.dataset.preorder || '';
    addLabel = preorderNote ? 'Pre-order' : 'Add to Bag';
    qtyValEl.textContent = '1';
    titleEl.textContent  = title;
    detailsLink.href     = url;
    submitBtn.textContent = addLabel;
    submitBtn.disabled    = false;
    submitBtn.classList.remove('is-success', 'is-error');

    if (imageEl) {
      if (image) { imageEl.src = image; imageEl.alt = title; imageEl.hidden = false; }
      else { imageEl.hidden = true; }
    }

    variantsEl.innerHTML = '';
    var hideSingle = variants.length === 1 && variants[0].title === 'Default Title';
    variantsEl.style.display = hideSingle ? 'none' : '';

    variants.forEach(function (v, i) {
      if (hideSingle) { selectedVariant = v; showPrice(v); return; }
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'quick-add__variant';
      btn.textContent = v.title;
      btn.disabled = !v.available;
      btn.dataset.id = v.id;
      if (i === 0 && v.available) {
        btn.classList.add('is-selected');
        selectedVariant = v;
        showPrice(v);
      }
      btn.addEventListener('click', function () {
        variantsEl.querySelectorAll('.quick-add__variant').forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        selectedVariant = v;
        showPrice(v);
        previewShipBar();   // ounces changed → live-update the bar
      });
      variantsEl.appendChild(btn);
    });

    drawer.setAttribute('aria-hidden', 'false');
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    refreshCartTotalThenPreview();
  }

  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  // Quantity — live-update the ship bar preview
  drawer.querySelectorAll('.quick-add__qty-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      qty = Math.max(1, qty + parseInt(btn.dataset.change, 10));
      qtyValEl.textContent = qty;
      previewShipBar();   // number of bags changed → live-update the bar
    });
  });

  // Submit
  submitBtn.addEventListener('click', function () {
    if (!selectedVariant || submitBtn.disabled) return;
    submitBtn.disabled    = true;
    submitBtn.classList.remove('is-error');
    submitBtn.textContent = 'Adding...';

    var payload = { id: selectedVariant.id, quantity: qty };
    if (preorderNote) payload.properties = { 'Pre-order': preorderNote };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return fetch('/cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var badge = document.querySelector('.header-cart-count');
        if (badge) badge.textContent = cart.item_count;
        cartTotalCents = cart.total_price;
        if (window.FMCart && window.FMCart.updateShipBars) window.FMCart.updateShipBars(cart.total_price);
        submitBtn.textContent = 'Added to bag ✓';
        submitBtn.classList.add('is-success');
        setTimeout(close, 1500);
      })
      .catch(function () {
        // M2: real failure state instead of a false "Added" — most often sold out
        submitBtn.disabled = false;
        submitBtn.classList.add('is-error');
        submitBtn.textContent = "Couldn't add — try again";
        setTimeout(function () { submitBtn.classList.remove('is-error'); submitBtn.textContent = addLabel; }, 2500);
      });
  });

  // Close
  closeBtn.addEventListener('click', close);
  backdrop.addEventListener('click', close);
  document.addEventListener('keydown', function (e) {
    // Only close the drawer with Escape if the welcome popup isn't on top of it
    var popup = document.getElementById('welcome-popup');
    var popupOpen = popup && popup.classList.contains('is-open');
    if (e.key === 'Escape' && drawer.classList.contains('is-open') && !popupOpen) close();
  });

  // Open — delegated so it works after dynamic renders
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.js-quick-add');
    if (!trigger) return;
    e.preventDefault();
    open(trigger);
  });
})();
